import React from "react";
import cls from "./Header.module.scss";
import cx from "classnames";
import Logo from "./Logo";
import NavBar from "./NavBar";
import { Route, Switch } from "react-router";
import ConsentPage from "routes/consent-page/ConsentPage";
import { LoginRoutes } from "config/LoginConfig";

export type HeaderProps = { className?: string };

const Header: React.FC<HeaderProps> = React.memo(({ className }) => (
  <div className={cx(cls.element, className)}>
    <Logo />
    <Switch>
      <Route path={LoginRoutes.CONSENT}>
      </Route>
      <Route path="*">
        <NavBar />
      </Route>
    </Switch>
  </div>
));

export default Header;
